// 新聞頁面 - 進度條功能列
'use client';

import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { popState } from '@/slices/popSlice';

import NewsCollectButton from './NewsCollectButton'; // 收藏按鈕
import NewsShare from './NewsShare'; // 新聞社群分享
import { setNewsSocialCount } from '@/slices/newsSlice';

const NewsProgressBar = ({ news }) => {
    const dispatch = useDispatch();
    const { showMenu } = useSelector(popState);

    const [y, setY] = useState(null);
    const [showBar, setShowBar] = useState(false);
    const [progress, setProgress] = useState(0);

    // 處理進度條
    const handleProgressBar = useCallback(() => {
        const scrollY = document.documentElement.scrollTop; // 滾動的距離
        const scrollHeight = document.documentElement.scrollHeight; // 滾動總長度
        const clientHeight = document.documentElement.clientHeight; // 可視區域的高度

        const scrollPercentage = (scrollY / (scrollHeight - clientHeight)) * 100;

        setProgress(scrollPercentage.toFixed(2));

        if (scrollY > 170) {
            if (y > scrollY) {
                setShowBar(false);
            } else if (y < scrollY) {
                setShowBar(true);
            }
        } else {
            setShowBar(false);
        }
        setY(scrollY);
    }, [y]);

    // 紀錄按讚、收藏、分享數量
    const handelSocialCount = () => {
        if (!news || !news?.id) return;

        dispatch(
            setNewsSocialCount({
                share: news?.share,
                thumb: news?.thumb,
                favorite: news?.favorite,
                isFavorite: news?.isFavorite,
            })
        );
    };

    useEffect(() => {
        setY(window.scrollY);
        window.addEventListener('scroll', handleProgressBar);

        return () => window.removeEventListener('scroll', handleProgressBar);
    }, [handleProgressBar]);

    useEffect(() => {
        handelSocialCount();
    }, [news]);

    return (
        <div
            className={`ulg:hidden fixed trans ${
                showMenu ? 'left-[200px] w-[calc(100vw-200px)]' : 'left-[60px] w-[calc(100vw-60px)]'
            }
            ${showBar ? ' top-0' : 'top-[-54px]'}
            z-[6] h-[54px] bg-black between-center gap-x-[15px] pl-[13px] pr-[20px] border-b-1 border-black9`}
        >
            {/* 標題 */}
            <p className="text-bd1m text-white flex-grow line-clamp-1">{news?.title}</p>

            <div className="flex items-center flex-shrink-0 gap-x-[15px]">
                {/* 收藏按鈕 */}
                <NewsCollectButton location="progress" newsId={news?.id} />

                <span className="w-[1px] h-[10px] border-l-1 border-black2" />

                {/* 社群分享 */}
                <NewsShare location="progress" newsId={news?.id} />
            </div>

            {/* 進度 */}
            <hr
                style={{ width: `${progress}%` }}
                className="absolute bottom-[1px] border-t-[2px] border-b-0 left-0 border-bou"
            />
        </div>
    );
};

export default NewsProgressBar;
